module.exports = __webpack_public_path__ + "static/img/13.9e84aec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/3/zh/13.png
// module id = EdXx
// module chunks = 0